import { useEffect, useRef, useState } from "react";

export const useCountdown = (initialState: number, callback?: () => void) => {
	const [isRunning, setIsRunning] = useState(true);
	const [countdown, setCountdown] = useState(initialState);
	const savedCallback = useRef(callback);

	const handleResetTimeout = (isRunning?: boolean) => {
		setCountdown(initialState);
		if (isRunning !== undefined) {
			setIsRunning(isRunning);
		}
	};

	useEffect(() => {
		savedCallback.current = callback;
	}, [callback]);

	useEffect(() => {
		setCountdown(initialState);
	}, [initialState]);

	useEffect(() => {
		if (!isRunning) {
			return;
		}
		if (countdown <= 0) {
			savedCallback.current?.();
			setIsRunning(false);
			return;
		}
		const timer = setTimeout(() => {
			setCountdown((prevState) => prevState - 1);
		}, 1000);
		return () => clearTimeout(timer);
	}, [isRunning, countdown]);

	return { countdown: countdown, startCountdown: setIsRunning, resetCountdown: handleResetTimeout };
};
